// extracted by mini-css-extract-plugin
module.exports = {"card":"ScoreCard_card__-cvJN"};